import { type SyntheticEvent } from 'react';

export function preventDefault<Event extends Pick<SyntheticEvent, 'preventDefault'>>(event: Event): Event {
  event.preventDefault();

  return event;
}
